import React from 'react'
import FirebaseContext from './FirebaseContext'

export default function useFirebase() {
  return React.useContext(FirebaseContext)
}
